const config = {
    api_url: process.env.VUE_APP_API_URL,
    aws_subfolder: process.env.VUE_APP_AWS_SUBFOLDER,
    tutorial_link: process.env.VUE_APP_TUTORIAL_VIDEO || ''
}

export default {
    config
}